import {number, route, string, union} from 'react-router-typesafe-routes';

export const foodDiaryRoutesPath = route({
  children: {
    foodDiary: route({
      children: {
        editTrackers: route({
          path: 'edit-trackers',
        }),
        meal: route({
          path: 'meal',
          searchParams: {
            date: number().defined(),
            id: string().defined(),
            type: union(['breakfast', 'dinner', 'lunch', 'other', 'snacks']),
          },
          state: {
            date: number(),
            meal: string(), // MealRouterDTO
          },
        }),
      },
      path: 'food-diary',
      searchParams: {
        date: number(),
      },
    }),
    foodDiaryOnboarding: route({
      path: 'food-diary-onboarding',
    }),
  },
});
